// extracted by mini-css-extract-plugin
export default {"chips":"common_carousel-module__chips--23PkG","wrapper":"common_carousel-module__wrapper--2AfqH","inner":"common_carousel-module__inner--QoFdt"};